import FormEvidence from "./components/FormEvidence";
import { useMonthlyReportPdfCommand } from "./hooks/useMonthlyReportPdfCommand";

function RegisterMonthlyReportPdf() {
  const {
    monthlyReportPdf,
    createMonthlyReportPdf,
    errors: { errors },
    handleChange,
    loading,
  } = useMonthlyReportPdfCommand();

  const handleSubmit = (event) => {
    event.preventDefault();
    createMonthlyReportPdf(monthlyReportPdf);
  };

  return (
    <main className="container p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Registrar informe mensual</h1>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3">
          <div className="w-100">
            <p>
              Formulario de registro de informes mensuales. Asegúrate de completar
              todos los campos requeridos.
            </p>
            <FormEvidence
              data={monthlyReportPdf}
              onChange={handleChange}
              onSubmit={handleSubmit}
              errors={errors}
              loading={loading}
              typeFiles=".pdf"
            />
          </div>
        </div>
      </section>
    </main>
  );
}

export default RegisterMonthlyReportPdf;